import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonTitle,
  IonBackButton,
  IonNote,
  IonInput,
  IonRow,
  IonCol,
  IonPage,
  IonFooter,
  IonText
} from '@ionic/react';
import './Sendjob.css';
import AboutPopover from '../components/AboutPopover';
import {fingerPrint, calculator} from 'ionicons/icons';
import {RouteComponentProps} from "react-router";
import {StaticEvent} from "../_/StaticEvent";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import _ from "../_";
import {AuthComponent} from "./_/AuthComponent";
import {Observable} from 'rxjs/internal/Observable';
import {EmptyError} from 'rxjs/internal/util/EmptyError';
import {Subject} from 'rxjs/internal/Subject';

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: any,
  showPopoverEvent: any,

  pageData?: any,
  _userData?: any,
}

export function lastValueFrom<T>(source: Observable<T>) {
  return new Promise<T>((resolve, reject) => {
    let _hasValue = false;
    let _value: T;
    source.subscribe({
      next: value => {
        _value = value;
        _hasValue = true;
      },
      error: reject,
      complete: () => {
        if (_hasValue) {
          resolve(_value);
        } else {
          reject(new EmptyError());
        }
      },
    });
  });
}

class FastLoginSet extends AuthComponent<Props, State> {
  static RoutePathname = /^\/fastloginset/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null
    };
  }

  async componentDidMount() {
    await super.componentDidMount();

    //必須要引用 AuthComponent, 才能在這裡拿取用戶資料
    //若是引用 BaseComponent 則不需要下面
    // @ts-ignore
    this.setState({
      _userData: this._userData,
    });
  }

  async afterEventsLoader() {
    window.setTimeout(() => {
      debugger;
      const myPathname = this.props.location.pathname;
      if (myPathname.match(FastLoginSet.RoutePathname)) {
        if (this._doLoadingPageDataInDidMount) {
          this._doLoadingPageDataInDidMount = false;
          this._loadPageData();
        } else {
          return;
        }
      }
    }, 1);
  }

  async _loadPageData() {
    // WAITING SCREEN
    StaticEvent.LoadingEvent.next(true);

    // POST
    let postData = {};
    const postUrl = ApiService.urlMapping('~/api/1/fastloginsignup');
    Static.apiService
      .post(postUrl, postData)
      .subscribe(async (res: any) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);

          let data = res.data;
          _.debugManager.log(data);

          let error = data.error || null;
          let result = error == null;

          if (result) { // SUCEESS

            let payload = data.payload;
            _.debugManager.log(payload);

            this.loadPageData_OnlyOnceGuard = true;

            this.setState({
              pageData: {...payload},
            });


          } else {
            // AUTH USER EXPIRED
            if (error.code == 2) {
              alert('帳號被登出，請重新登入');
              window.location.href = '/login';
              //this.props.history.push('/login')
              return;
            }

            alert(error.message);
          }
        }, async (err) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);
          _.debugManager.warn(err);
          alert('網路連線有問題');
        }
      );
  }

  async signupDevice(devicekey: string) {

    // @ts-ignore
    //const {devicekey} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (devicekey) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      let ret = new Subject();
      let ret$ = ret.asObservable();

      // POST
      let postData = {
        devicekey: devicekey,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_fastloginsignup/device');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              alert('申請成功');

              // @ts-ignore
              //this.props.history.push('/login')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

              let payload = data.payload;
              ret.next(payload.DeviceKey)
              ret.complete();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
              ret.next(null)
              ret.complete();

            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');

            ret.next(null)
            ret.complete();
          }
        );
      return lastValueFrom(
        ret$
      );
    }
  }

  async signupDeviceLockless() {

    // @ts-ignore
    //const {email, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    if (true) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST

      let ret = new Subject();
      let ret$ = ret.asObservable();

      let postData = {};
      const postUrl = ApiService.urlMapping('~/api/1/_fastloginsignup/devicelockless');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              alert('申請成功');

              let payload = data.payload;
              ret.next(payload.DeviceLocklessKey)
              ret.complete();

              // @ts-ignore
              //this.props.history.push('/login')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();

              ret.next(null)
              ret.complete();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');

            ret.next(null)
            ret.complete();
          }
        );
      return lastValueFrom(
        ret$
      );
    }
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  }

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  }

  async enroll() {
    const challenge = new Uint8Array(32);
    //const challenge = new Uint8Array([1, 2, 3, 4]);
    const publicKeyOptions = {
      rp: {name: "LocalAuth", id: window.location.hostname},
      user: {id: new Uint8Array([1]), name: "User", displayName: "User"},
      challenge: challenge,
      pubKeyCredParams: [{alg: -7, type: "public-key"}],
    };
    try {
      const credential: any = await navigator.credentials.create({
        publicKey: publicKeyOptions
      } as any);

      Static.storageService.setDeviceKey(credential.rawId);
      return credential.rawId;
    } catch (err) {

      if (err.name === 'NotAllowedError') {
        return; //ignore
      } else {
        alert(err);
      }

      return false;
    }
  }

  async check() {

    let deviceKey = Static.storageService.getDeviceKey();

    const options = {
      allowCredentials: [{
        id: deviceKey,
        type: 'public-key'
      }],
      challenge: new Uint8Array([4, 5, 7, 8]),
    }

    const assertion: any = await navigator.credentials.get({
      publicKey: options
    } as any);

    alert("Authenticated user" + new Uint8Array(assertion.response.userHandle)[0])
  }

  async registerDeviceLockless(e: any, isConfirm = false) {
    e.preventDefault();
    e.stopPropagation();

    let registerBody = async () => {
      let key: any = await this.signupDeviceLockless();
      Static.storageService.setDeviceLocklessKey(key);

      // @ts-ignore
      this.props.history.push('/')
    }

    if (isConfirm) {
      if (confirm('已經有申請過設備綁定登入，將重新申請並無效化其他設備的數據 (若有多個設備，將以此設備為基準)')) {
        await registerBody();
      }
    } else {
      await registerBody();
    }

    // if (Static.storageService.getDeviceLocklessKey()) {
    //
    // }
  }

  async registerDevice(e: any, isConfirm = false) {
    e.preventDefault();
    e.stopPropagation();

    let registerBody = async () => {
      if (await this.enroll()) {
        if (await this.signupDevice(Static.storageService.getDeviceKeyBase64())) {  //確定主機有得到 crediental id
          //Done註冊成功

          // @ts-ignore
          this.props.history.push('/')
        }
      }
    }

    if (isConfirm) {
      if (confirm('已經有申請過設備綁定登入，將重新申請並無效化其他設備的數據 (若有多個設備，將以此設備為基準)')) {
        await registerBody();
      }
    } else {
      await registerBody();
    }


    // const userID = 'Kosv9fPtkDoh4Oz7Yq/pVgWHS8HhdlCto5cR0aBoVMw=';
    // const id = Uint8Array.from(window.atob(userID), c => c.charCodeAt(0));
    //
    // const challenge = new Uint8Array(32);
    // window.crypto.getRandomValues(challenge);
    //
    //
    // let publicKeyCredentialRequestOptions = {
    //   challenge,
    //   allowCredentials: [{
    //     id: id, // from registration
    //     type: 'public-key',
    //     //transports: ['internal','usb', 'ble', 'nfc'],
    //     transports: ['internal'],
    //   }],
    //   timeout: 60000,
    // }
    //
    // const assertion = await navigator.credentials.get({
    //   publicKey: publicKeyCredentialRequestOptions
    // } as any);
  }

  async login(e: any) {
    e.preventDefault();
    e.stopPropagation();

    await this.check();
  }


  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={() => this.props.history.goBack()} text="返回"/>
            </IonButtons>
            <IonTitle>選擇要免填寫即可登入</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonPopover
          isOpen={this.state.showPopover}
          event={this.state.showPopoverEvent}
          onDidDismiss={this.dismissPopover}
        >
          <AboutPopover
            dismissPopover={this.dismissPopover}
          />
        </IonPopover>

        <IonContent>
          <div className="infopage">
            <h3>選擇哪一種免輸入方式？</h3>
            {/* <p>為了讓登入更安全方便，增設二種快速登入方式，您可選擇其中一種作為你的登入方式：</p> */}
            {/* <div className="infoinnerpage">
              <h4>1.生物辨識登入方式（如臉部或指紋辨識）</h4>
              <p>我們將請求啟用生物辨識功能的權限，透過你使用的瀏覽器，會需要您的核准。<br/>
              瀏覽器會詢問設定密碼(PIN碼)，才能開啟生物辨識功能</p>

              <h4>2.綁定工人常用的設備登入方式</h4>
              <p>將您使用的設備與平台綁定，每次登入只要是使用該設備就能快速進入</p>

              <h5>我們會如何使用：</h5>
              <ul>
                <li>取代輸入密碼，快速登入「工人雲端平台」</li>
              </ul>

              <h5>我們不會做的事：</h5>
              <ul>
                <li>❌ 不會儲存您的生物特徵及設備資料</li>
                <li>❌ 不會將您的辨識資訊傳送到伺服器</li>
              </ul>
              辨識功能開啟後，您也可隨時解除綁定此功能。
            </div> */}

            <IonRow>
              {(this.state.pageData && this.state.pageData.CanDevice) ?
                <IonCol>
                  <IonButton size="large" color="primary" expand="block" type="submit" onClick={(e) => this.registerDevice(e)}>
                    <IonIcon slot="start" icon={fingerPrint}></IonIcon>用臉部或指紋辨識
                  </IonButton>
                  <div className="infohint">（請同意啟動瀏覽器使用權限）</div>
                </IonCol> : <IonCol>
                  <IonButton size="large" color="primary" expand="block" type="submit" onClick={(e) => this.registerDevice(e)}>
                    <IonIcon slot="start" icon={fingerPrint}></IonIcon>用臉部或指紋辨識
                    {/* (已申請有綁定設備) */}
                  </IonButton>
                  <div className="infohint">（請同意啟動瀏覽器使用權限）</div>
                </IonCol>

              }
              {(this.state.pageData && this.state.pageData.CanDeviceLockless) ?
                <IonCol>
                  <IonButton size="large" color="primary" expand="block" type="submit" onClick={(e) => this.registerDeviceLockless(e, true)}>
                    <IonIcon slot="start" icon={calculator}></IonIcon>全部都不用輸入
                  </IonButton>
                  <div className="infohint">（綁定你正在使用的設備）</div>
                </IonCol> : <IonCol>
                  <IonButton size="large" color="primary" expand="block" type="submit" onClick={(e) => this.registerDeviceLockless(e, true)}>
                    <IonIcon slot="start" icon={calculator}></IonIcon>全部都不用輸入
                    {/* (已申請有綁定設備) */}
                  </IonButton>
                  <div className="infohint">（綁定你正在使用的設備）</div>
                </IonCol>
              }
            </IonRow>
            <IonRow>
            </IonRow>
          </div>

        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
  isAuthenticated: state.user.isAuthenticated
});

export default connect(
  mapStateToProps
)(FastLoginSet);
